/* ------------------------------------------------------------------
  File: TestPage.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-13
------------------------------------------------------------------ */

// Purpose:
//   - Describe the purpose of this component.

import { useState } from "react";
import Button from "../../shared/components/ui/Buttons/Button";
import "./TestPage.css";

import { IoMdMenu } from "react-icons/io";
import { FiCpu } from "react-icons/fi";
import { FaRegBuilding } from "react-icons/fa";

import { IconButton } from "../../shared/components/ui/Buttons";
import { BaseCard, InfoCard, LinkCard, StatCard } from "../../shared/components/ui/Cards";
import { LuBriefcase, LuBuilding2, LuCpu, LuFileSearch, LuInfo, LuSparkles } from "react-icons/lu";
import SectionHeader from "../../shared/components/ui/SectionHeader/SectionHeader";
import Badge from "../../shared/components/ui/Badge";
import Tag from "../../shared/components/ui/Tag/Tag";
import Accordion from "../../shared/components/ui/Accordion";
import Tabs from "../../shared/components/ui/Tabs";
import EmptyState from "../../shared/components/ui/EmptyState";
import Breadcrumb from "../../shared/components/ui/Breadcrumb";
import Loader from "../../shared/components/ui/Loader";
import Tooltip from "../../shared/components/ui/Tooltip";
import Alert from "../../shared/components/ui/Alert";
import Toast from "../../shared/components/ui/Toast";
import Pagination from "../../shared/components/ui/Pagination";

const TestPage = () => {
  const handleStartConversation = () => {
    alert("Start conversation button clicked");
  };

  const sectorTabs = [
    {
      id: "technology",
      label: "Technology",
      icon: <LuCpu />,
      content: <p className="u-type-body">Digital platforms and systems.</p>,
    },
    {
      id: "engineering",
      label: "Engineering",
      icon: <LuBuilding2 />,
      content: <p className="u-type-body">Infrastructure and technical services.</p>,
    },
  ];

  const tabItems = [
    {
      id: "technology",
      label: "Technology",
      content: (
        <p className="u-type-body">
          Software, platforms, automation, and digital transformation.
        </p>
      ),
    },
    {
      id: "engineering",
      label: "Engineering",
      content: (
        <p className="u-type-body">
          Infrastructure, technical systems, and engineering solutions.
        </p>
      ),
    },
  ];

  const faqItems = [
    {
      id: "what-is-accend",
      title: "What is Accend Holdings?",
      content:
        "Accend Holdings Ltd. is a corporate group focused on building and scaling enterprises across strategic growth sectors.",
    },
    {
      id: "what-sectors",
      title: "What sectors does Accend focus on?",
      content:
        "Accend focuses on technology, engineering, telecommunications, enterprise services, and other long-term growth sectors.",
    },
  ];

  const investorItems = [
    {
      id: "strategic-capital",
      title: "Strategic Capital",
      content: (
        <div className="l-stack l-stack--sm">
          <p>
            Accend Holdings aligns capital with enterprise-building opportunities
            across strategic sectors.
          </p>
          <p>
            Our approach focuses on long-term value creation, governance, and
            disciplined execution.
          </p>
        </div>
      ),
    },
  ];

  const [showToast, setShowToast] = useState(true);
  const [page, setPage] = useState(1);
  const [compactPage, setCompactPage] = useState(6);
  const [fewPages, setFewPages] = useState(1);

  return (
    <div className="l-section l-section--base test-page">
      <div className="l-container l-container--max test-page__container ">
        {/* Typography */}
        <section className="l-section l-section--base ">
          <h1 className="u-type-display ">The quick brown fox jump over the lazy dog.</h1>
          <br />

          <span className="u-eyebrow ">The quick brown fox jump over the lazy dog.</span>
          <h1 className="u-type-hero ">The quick brown fox jump over the lazy dog.</h1>
          <h1 className="u-type-page-title ">The quick brown fox jump over the lazy dog.</h1>
          <h2 className="u-type-section-title ">The quick brown fox jump over the lazy dog.</h2>
          <p className="u-type-intro ">The quick brown fox jump over the lazy dog.</p>
          <p className="u-type-lead ">The quick brown fox jump over the lazy dog.</p>
          <p className="u-type-body ">The quick brown fox jump over the lazy dog.</p>
          <br />

          <span className="u-type-meta ">The quick brown fox jump over the lazy dog.</span>
          <br />

          <small className="u-type-legal ">The quick brown fox jump over the lazy dog.</small>
        </section>

        {/* Buttons */}
        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Button System</h1>
          <br />
          <div className="l-cluster l-cluster--spaced surface--dark">
            <Button
              href="https://google.com"
              target="_blank"
            >
              Contact Us
            </Button>

            <Button
              to="/contact"
              variant="secondary"
              className="test-button"
            >
              Contact Us
            </Button>

            <Button
              onClick={handleStartConversation}
              variant="outline"
            >
              Contact Us
            </Button>

            <Button
              variant="ghost"
            >
              Contact Us
            </Button>
            <Button
              variant="link"
            >
              Contact Us
            </Button>
          </div>

          <br />
          
          <div className="l-cluster l-cluster--spaced">
            <Button>
              Contact Us
            </Button>

            <Button
              variant="secondary"
            >
              Contact Us
            </Button>

            <Button
              variant="outline"
            >
              Contact Us
            </Button>

            <Button
              variant="ghost"
            >
              Contact Us
            </Button>
            <Button
              variant="link"
            >
              Contact Us
            </Button>
          </div>
          <br />
          
          <div className="l-cluster l-cluster--spaced">
            <Button
              size="sm"
            >
              Contact Us
            </Button>

            <Button
              size="sm"
              variant="secondary"
            >
              Contact Us
            </Button>

            <Button
              size="sm"
              variant="outline"
            >
              Contact Us
            </Button>

            <Button
              size="sm"
              variant="ghost"
            >
              Contact Us
            </Button>

            <Button
              size="sm"
              variant="link"
            >
              Contact Us
            </Button>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Icon Button System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <IconButton
              icon={<IoMdMenu />}
              ariaLabel="Open navigation menu"
              variant="primary"
              size="md"
              onClick={handleStartConversation}
            />

            <IconButton
              icon={<IoMdMenu />}
              ariaLabel="Open navigation menu"
              variant="secondary"
              size="md"
              onClick={handleStartConversation}
            />

            <IconButton
              icon={<IoMdMenu />}
              ariaLabel="Open navigation menu"
              variant="outline"
              size="md"
              onClick={handleStartConversation}
            />

            <IconButton
              icon={<IoMdMenu />}
              ariaLabel="Open navigation menu"
              variant="ghost"
              size="md"
              onClick={handleStartConversation}
            />

            <IconButton
              icon={<IoMdMenu />}
              ariaLabel="Open navigation menu"
              variant="soft"
              size="md"
              onClick={handleStartConversation}
            />
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Base Card System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <BaseCard>
              <h3 className="u-type-card-title">Accend Technologies</h3>
              <p className="u-type-body">
                Building digital systems that help organizations modernize and grow.
              </p>
            </BaseCard>

            <BaseCard hoverable>
              <h3 className="u-type-card-title">Technology</h3>
              <p className="u-type-body">
                Software, platforms, automation, and digital transformation.
              </p>
            </BaseCard>

            <BaseCard as="article" hoverable fullHeight>
              <h3 className="u-type-card-title">Strategic Enterprise Building</h3>
              <p className="u-type-body">
                Accend Holdings builds companies for long-term institutional impact.
              </p>
            </BaseCard>

            <BaseCard variant="soft" padding="lg">
              <h3 className="u-type-card-title">Our Long-Term Focus</h3>
              <p className="u-type-body">
                We invest in sectors that strengthen Africa's economic future.
              </p>
            </BaseCard>

            <BaseCard>
              <div className="l-stack l-stack--sm">
                <h3 className="u-type-card-title">Technology</h3>
                <p className="u-type-body">
                  Digital systems and software products.
                </p>
              </div>
            </BaseCard>
          </div>
          <br />

          <div className="l-grid l-grid--3">
            <BaseCard hoverable fullHeight>
              <h3 className="u-type-card-title">Technology</h3>
              <p className="u-type-body">Digital systems and software products.</p>
            </BaseCard>

            <BaseCard hoverable fullHeight>
              <h3 className="u-type-card-title">Engineering</h3>
              <p className="u-type-body">Infrastructure, systems, and technical services.</p>
            </BaseCard>

            <BaseCard hoverable fullHeight>
              <h3 className="u-type-card-title">Telecommunications</h3>
              <p className="u-type-body">Connectivity, networks, and communication systems.</p>
            </BaseCard>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Info Card System</h1>
          <br />

          <InfoCard
            icon={<FiCpu />}
            eyebrow="Technology"
            title="Digital Systems & Platforms"
            description="We build scalable digital tools, websites, platforms, and automation systems for modern organizations."
            hoverable
            fullHeight
            action={
              <Button to="/business/technology" variant="link" size="sm">
                Learn More
              </Button>
            }
          />
          <br />

          <div className="l-grid l-grid--3">
            <InfoCard
              title="Technology"
              description="Software, platforms, automation, and digital transformation."
              hoverable
              fullHeight
            />

            <InfoCard
              title="Engineering"
              description="Infrastructure, technical systems, and engineering solutions."
              hoverable
              fullHeight
            />

            <InfoCard
              title="Telecommunications"
              description="Connectivity, networks, and communication systems."
              hoverable
              fullHeight
            />
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Link Card System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <LinkCard
              to="/business/technology"
              icon={<FaRegBuilding />}
              eyebrow="Subsidiary"
              title="Accend Technologies"
              description="Building digital platforms, software systems, and automation tools for modern organizations."
              actionLabel="Explore Company"
              hoverable
              fullHeight
            />

            <LinkCard
              href="https://example.com"
              target="_blank"
              eyebrow="Partner"
              title="Strategic Partner"
              description="Learn more about one of our external strategic partners."
              actionLabel="Visit Website"
            />
          
          </div>

          <br />

          <div className="l-grid l-grid--3">
            <LinkCard
              to="/business/technology"
              title="Technology"
              description="Software, platforms, automation, and digital transformation."
              actionLabel="Explore Sector"
              fullHeight
            />

            <LinkCard
              to="/business/engineering"
              title="Engineering"
              description="Infrastructure, technical systems, and engineering solutions."
              actionLabel="Explore Sector"
              fullHeight
            />

            <LinkCard
              to="/business/telecommunications"
              title="Telecommunications"
              description="Connectivity, networks, and communication systems."
              actionLabel="Explore Sector"
              fullHeight
            />
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Stats Card System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <StatCard
              value="10+"
              label="Operating Sectors"
              description="Strategic sectors where Accend Holdings is building long-term enterprise value."
            />

            <StatCard
              value="30"
              label="Year Vision"
              description="Our long-term ambition is to build an institutional corporate group with global relevance."
              align="center"
            />

            <StatCard
              icon={<LuBuilding2 />}
              eyebrow="Portfolio"
              value="6+"
              label="Business Units"
              description="A growing ecosystem of companies and operating divisions."
              hoverable
              fullHeight
            />
          </div>

          <br />

          <div className="l-grid l-grid--3">
            <StatCard
              value="6+"
              label="Business Units"
              description="A growing ecosystem of Accend companies and divisions."
              fullHeight
            />

            <StatCard
              value="10+"
              label="Strategic Sectors"
              description="Focused sectors across technology, engineering, telecoms, and enterprise services."
              fullHeight
            />

            <StatCard
              value="30"
              label="Year Vision"
              description="A long-term plan to build a Fortune 500-level corporate group from Africa."
              fullHeight
            />
          </div>
        </section>

        <section className="l-section l-section--base ">
          <SectionHeader
            eyebrow="Business"
            title="Operating Sectors"
            text="Accend Holdings builds and scales enterprises across strategic growth sectors."
          />
        </section>

        <section className="l-section l-section--base ">
          <SectionHeader
            align="center"
            eyebrow="About Accend"
            title="Building enterprises for long-term institutional impact."
            text="We are developing a corporate group designed for structure, scale, and long-term value creation."
          />
        </section>

        <section className="l-section l-section--base ">
          <SectionHeader
            eyebrow="Newsroom"
            title="Latest Insights"
            text="Explore updates, articles, and strategic perspectives from Accend Holdings."
            action={
              <Button to="/newsroom" variant="outline" size="md">
                View All Insights
              </Button>
            }
          />

        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <SectionHeader
                eyebrow="Our Companies"
                title="A growing ecosystem of Accend businesses."
                text="Across technology, engineering, telecommunications, and enterprise services, we are building companies for long-term growth."
              />

              <div className="l-grid l-grid--3">
                {/* Cards go here */}
              </div>
            </div>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Badge System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <Badge>Featured</Badge>
            <Badge variant="success">Active</Badge>
            <Badge variant="brand">Subsidiary</Badge>
            <Badge variant="warning">Coming Soon</Badge>

            <Badge icon={<LuSparkles />} variant="accent">
              Featured
            </Badge>

            <BaseCard>
              <div className="l-stack l-stack--sm">
                <Badge variant="brand">Operating Sector</Badge>

                <h3 className="u-type-card-title">Technology</h3>

                <p className="u-type-body">
                  Software, platforms, automation, and digital transformation.
                </p>
              </div>
            </BaseCard>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Tag Component System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <div className="l-cluster l-cluster--tight">
              <Tag>Technology</Tag>
              <Tag>Engineering</Tag>
              <Tag>Telecommunications</Tag>

              <Tag as="button" selected onClick={handleStartConversation}>
                Technology
              </Tag>

              <Tag removable onRemove={handleStartConversation}>
                Governance
              </Tag>

              <Tag icon={<LuBuilding2 />} variant="neutral">
                Infrastructure
              </Tag>


            </div>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Accordion System</h1>
          <br />

          <Accordion items={faqItems} />
          <br />

          <h2 className="u-type-section-title ">Accordion with multiple open items</h2>
          <br />

          <Accordion
            items={faqItems}
            allowMultiple
            defaultOpenItems={["what-is-accend"]}
          />
          <br />

          <h2 className="u-type-section-title ">Accordion with border</h2>
          <br />

          <Accordion
            items={faqItems}
            variant="bordered"
          />
          <br />

          <Accordion items={investorItems} variant="bordered" />;
        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <SectionHeader
                eyebrow="FAQ"
                title="Frequently Asked Questions"
                text="Find quick answers about Accend Holdings, our businesses, and how to engage with us."
              />

              <Accordion items={faqItems} variant="bordered" />
            </div>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Tabs System</h1>
          <br />

          <Tabs items={tabItems} />
          <br />

          <Tabs items={sectorTabs} variant="pills" />
          <br />

          <Tabs
            items={tabItems}
            variant="underline"
            align="center"
            defaultActiveId="technology"
          />
          <br />

          <Tabs
            items={tabItems}
            variant="boxed"
            size="md"
          />
          <br />

        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <SectionHeader
                eyebrow="Business"
                title="Explore our strategic sectors."
                text="Accend Holdings builds across sectors that support long-term enterprise growth."
              />

              <Tabs items={sectorTabs} variant="pills" />
            </div>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Empty State</h1>
          <br />

          <EmptyState
            title="No articles found"
            text="There are no newsroom articles available at the moment."
          />
          <br />

          <EmptyState
            icon={<LuFileSearch />}
            eyebrow="No Results"
            title="No matching results found"
            text="Try adjusting your search term or filters."
          />
          <br />

          <EmptyState
            icon={<LuBriefcase />}
            eyebrow="Careers"
            title="No open roles right now"
            text="We are not currently listing open positions, but you can still reach out to us."
            variant="bordered"
            action={
              <Button to="/contact" variant="primary" size="md">
                Contact Accend
              </Button>
            }
          />
          <br />

          <EmptyState
            align="left"
            variant="soft"
            title="No investor resources available"
            text="Investor documents and updates will appear here when published."
          />
        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <EmptyState
              variant="bordered"
              title="No projects available"
              text="Project highlights will be published as Accend Holdings expands its portfolio."
            />
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Breadcrum System</h1>
          <br />

          <Breadcrumb
            items={[
              { label: "Business", to: "/business" },
              { label: "Technology", current: true },
            ]}
          />
          <br />

          <Breadcrumb
            items={[
              { label: "Newsroom", to: "/newsroom" },
              { label: "Strategic Enterprise Building", current: true },
            ]}
          />
          <br />

          <Breadcrumb
            showHome={false}
            items={[
              { label: "Investors", to: "/investors" },
              { label: "Reports", current: true },
            ]}
          />
          <br />

          <Breadcrumb
            separator="/"
            items={[
              { label: "Careers", to: "/careers" },
              { label: "Software Engineer", current: true },
            ]}
          />

        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Loader System</h1>
          <br />

          <div className="l-cluster l-cluster--spaced ">
            <Loader />
            <Loader label="Loading articles" showLabel />
            <Loader centered label="Loading projects" showLabel />
            
            <Loader variant="dots" label="Loading" showLabel />
            <Loader variant="bar" label="Loading resources" showLabel />
          </div>
          <br />

          {/* <Loader fullPage size="lg" label="Loading Accend Holdings" showLabel /> */}

        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <div className="l-stack l-stack--sm">
                <h1 className="u-type-page-title">Tooltip System</h1>
                <p className="u-type-body">
                  Testing tooltip behavior with icon buttons and multiple placements.
                </p>
              </div>

              <div className="l-cluster l-cluster--spaced">
                <Tooltip content="More information" placement="top">
                  <IconButton
                    icon={<LuInfo />}
                    ariaLabel="More information"
                    variant="ghost"
                    size="sm"
                  />
                </Tooltip>

                <Tooltip content="Tooltip on the right" placement="right">
                  <IconButton
                    icon={<LuInfo />}
                    ariaLabel="Right tooltip"
                    variant="ghost"
                    size="sm"
                  />
                </Tooltip>

                <Tooltip content="Tooltip on the bottom" placement="bottom">
                  <IconButton
                    icon={<LuInfo />}
                    ariaLabel="Bottom tooltip"
                    variant="ghost"
                    size="sm"
                  />
                </Tooltip>

                <Tooltip content="Tooltip on the left" placement="left">
                  <IconButton
                    icon={<LuInfo />}
                    ariaLabel="Left tooltip"
                    variant="ghost"
                    size="sm"
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <div className="l-stack l-stack--sm">
                <h1 className="u-type-page-title">Alert System</h1>
                <p className="u-type-body">
                  Testing alert variants, dismissible alerts, and alerts with actions.
                </p>
              </div>

              <div className="l-stack l-stack--md">
                <Alert title="Information">
                  This is an informational message for users.
                </Alert>

                <Alert variant="success" title="Message sent">
                  Your inquiry has been submitted successfully.
                </Alert>

                <Alert variant="warning" title="Notice">
                  Some information may require additional review.
                </Alert>

                <Alert variant="error" title="Submission failed">
                  We could not submit your request. Please try again.
                </Alert>

                <Alert variant="neutral" title="General notice">
                  This is a neutral alert for general system information.
                </Alert>

                <Alert
                  variant="info"
                  title="Investor resources"
                  action={
                    <Button to="/investors" variant="outline" size="sm">
                      View Resources
                    </Button>
                  }
                >
                  New investor resources are available for review.
                </Alert>

                <Alert
                  variant="success"
                  title="Dismissible alert"
                  dismissible
                  onDismiss={() => console.log("Alert dismissed")}
                >
                  This alert includes a dismiss button.
                </Alert>
              </div>
            </div>
          </div>
        </section>

        <section className="l-section l-section--base ">
          <h1 className="u-type-page-title ">Toast System</h1>
          <br />

          {/* <Toast
            title="Saved"
            message="Your changes have been saved successfully."
          /> */}

          {/* <Toast
            variant="success"
            title="Message sent"
            message="Your inquiry has been submitted successfully."
          /> */}

          {/* <Toast
            variant="error"
            title="Submission failed"
            message="Please check your connection and try again."
          /> */}

          {/* <Toast
            variant="info"
            title="Download started"
            message="Your file is being prepared."
            action={
              <Button variant="outline" size="sm">
                View
              </Button>
            }
          /> */}

          {showToast && (
            <Toast
              variant="success"
              title="Saved"
              message="Your changes have been saved successfully."
              onDismiss={() => setShowToast(false)}
            />
          )}

        </section>

        <section className="l-section l-section--base">
          <div className="l-container l-container--max">
            <div className="l-stack l-stack--lg">
              <div className="l-stack l-stack--sm">
                <h1 className="u-type-page-title">Pagination System</h1>
                <p className="u-type-body">
                  Testing default pagination, compact pagination, and smaller page sets.
                </p>
              </div>

              <div className="l-stack l-stack--md">
                <div className="l-stack l-stack--sm">
                  <h2 className="u-type-section-title">Default Pagination</h2>
                  <p className="u-type-body">Current page: {page}</p>

                  <Pagination
                    currentPage={page}
                    totalPages={12}
                    onPageChange={setPage}
                  />
                </div>

                <div className="l-stack l-stack--sm">
                  <h2 className="u-type-section-title">Compact Pagination</h2>
                  <p className="u-type-body">Current page: {compactPage}</p>

                  <Pagination
                    currentPage={compactPage}
                    totalPages={20}
                    onPageChange={setCompactPage}
                    variant="compact"
                  />
                </div>

                <div className="l-stack l-stack--sm">
                  <h2 className="u-type-section-title">Few Pages</h2>
                  <p className="u-type-body">Current page: {fewPages}</p>

                  <Pagination
                    currentPage={fewPages}
                    totalPages={4}
                    onPageChange={setFewPages}
                    showFirstLast={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>



      </div>
    </div>
  );
};

export default TestPage;